/**
 *  org-idaas-aggr
 *  @swagger http://org-idaas-aggr.earth.xpaas.lenovo.com/doc.html#/home
 */
import { IAjaxConfig } from '../libraries';
export class EnumApiOrgidasssvr {
  /**
   * 云学堂权限
   * @type {IAjaxConfig}
   * @memberof EnumApiIdass
   */
  readonly orgidass_get_yxt_permission: IAjaxConfig = {
    // url: '/api/gateway/org-idaas-aggr/v1/yxt/menu/permission/get',
    // url: '/api/gateway/bp-integrate-cultivate/user/isActivation',
    url: '/api/gateway/bp-integrate-cultivate/user/activation/check',
    method: 'get',
  };

  /**
   * 政企（大客户）注册
   * @type {IAjaxConfig}
   * @memberof EnumApiIdass
   */
  readonly orgidass_rel_register: IAjaxConfig = {
    url: '/api/gateway/org-idaas-aggr/public/rel/register',
    method: 'post',
  };
  /**
   * SMB快速注册
   * @type {IAjaxConfig}
   * @memberof EnumApiIdass
   */
  readonly orgidass_smb_register: IAjaxConfig = {
    url: '/api/gateway/org-idaas-aggr/public/smb/easy/register',
    method: 'post',
  };
}
